import './AddOrRemoveItemModal.scss';

import heartIcon from '@ingka/ssr-icon/paths/heart';
import trashCanIcon from '@ingka/ssr-icon/paths/trash-can';

import Button from '../../Skapa/Button/Button';
import Modal, { ModalBody, ModalFooter, ModalHeader, Sheets } from '../../Skapa/Modal/Modal';
import Text from '@ingka/text';

type Labels = {
  modal: {
    title: string;
    body: string;
  };
  footer: {
    goToAddItem: {
      label: string;
    };
    goToRemoveItem: {
      label: string;
    };
  };
};
export interface AddOrRemoveItemProps {
  isOpen: boolean;
  labels: Labels;
  onClose: () => void;
  onAdd: () => void;
  onRemove: () => void;
}
export const AddOrRemoveItem = (props: AddOrRemoveItemProps) => {
  const { isOpen, labels, onClose, onAdd, onRemove } = props;

  return (
    <Modal id="add-or-remove-modal" visible={isOpen} handleCloseBtn={() => onClose()} scrollLock={false}>
      <Sheets
        aria-label={labels.modal.title}
        header={<ModalHeader title={labels.modal.title} />}
        size="small"
        footer={
          <ModalFooter className="modalFooter">
            <Button
              ssrIcon={trashCanIcon}
              fluid={true}
              onClick={() => {
                onRemove();
              }}
              text={labels.footer.goToRemoveItem.label}
            />
            <Button
              ssrIcon={heartIcon}
              fluid={true}
              onClick={() => {
                onAdd();
              }}
              text={labels.footer.goToAddItem.label}
              type="primary"
            />
          </ModalFooter>
        }
      >
        <ModalBody>
          <Text textStyle="Body.M">{labels.modal.body}</Text>
        </ModalBody>
      </Sheets>
    </Modal>
  );
};
